import axios from "axios"
import useStorage from "./useStorage"
import { baseUrl, getSetting } from '@/utils/settings'
import { getServiceCode } from '@/utils/serviceCode'
import { useHistory } from 'react-router-dom'
const KEY_TOKEN_LOGIN = getSetting('KEY_TOKEN_LOGIN')
const KEY_USER_INFO = getSetting('KEY_USER_INFO')
const KEY_TENANT = getSetting('KEY_TENANT')
const KEY_LANG = getSetting('KEY_LANG')

export const useAxios = () => {
  const [, , removeUserInfo] = useStorage(KEY_USER_INFO)
  const [token, , removeToken] = useStorage(KEY_TOKEN_LOGIN)
  const [tenant, ,] = useStorage(KEY_TENANT)
  const [lang] = useStorage(KEY_LANG, 'zh-CN')
  const apiBaseUrl = baseUrl()
  const history = useHistory()

  function setServiceCodeHeader(config) {
    const serviceCode = getServiceCode()
    if (serviceCode) {
      config.headers.common["serviceCode"] = serviceCode
    }
  }

  return (isLogin: boolean) => {
    if (isLogin) {
      axios.defaults.baseURL = apiBaseUrl
      axios.interceptors.request.use(
        (config) => {
          config.headers.common["Authorization"] = "Bearer " + token
          config.headers.common["accept-language"] = lang == "zh-CN" ? "zh-Hans" : "en"
          if (tenant) config.headers.common["__tenant"] = tenant
          setServiceCodeHeader(config)
          return config
        },
        (error) => {
          return Promise.reject(error)
        }
      )
      //请求返回拦截，把数据返回到页面之前做些什么...
      axios.interceptors.response.use(
        (response) => {
          return response
        },
        (error) => {
          if (error.response) {
            if (error.response.status == 401) {
              //未经授权
              removeToken()
              removeUserInfo()
              window.location.reload()
            }
          }
          const realData = error && error.response ? error.response.data : undefined
          return Promise.reject(realData || error)
        }
      )
    }
    else {
      axios.defaults.baseURL = apiBaseUrl
      axios.interceptors.request.use(
        (config) => {
          config.headers.common["accept"] = "text/plain"
          config.headers.common["Content-Type"] = "application/json"
          config.headers.common["X-Requested-With"] = "XMLHttpRequest"
          setServiceCodeHeader(config)
          return config
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    }
  }

}

